<template>
    <el-row>
        <table-template :queryParams="queryParams" actionUrl="/friend/bindUser/findFriendCircleBindUserList.action"
                        ref="searchcarTable">
            <template slot="search">
                <el-select  @change="$refs['searchcarTable'].search()" clearable placeholder="是否禁用" style="margin-left:5px;"
                            v-model="queryParams.isEnable">
                    <el-option :value="1" label="启用"></el-option>
                    <el-option :value="2" label="禁用"></el-option>
                </el-select>

                <el-date-picker
                        style="margin-left:10px;"
                        v-model="queryParams.startEndTime"
                        @change="onDateTimeChange"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
              <el-input v-model="queryParams.keyword" style="margin-left:10px;width:200px;" placeholder="微信号/昵称/设备号/手机号"></el-input>

              <el-button style="margin-left:10px;" type="primary" @click="$refs['searchcarTable'].search()">搜索</el-button>

            </template>

            <template slot="item">
                <el-table-column
                        label="微信号"
                        prop="wechat">
                </el-table-column>

                <el-table-column
                    label="微信昵称"
                    prop="nickname">
              </el-table-column>
              <el-table-column
                  label="手机号"
                  prop="phone">
              </el-table-column>

                <el-table-column
                        label="设备号"
                        prop="deviceName">
                </el-table-column>


                <el-table-column
                        label="绑定时间"
                        prop="bindTime" width="230px">
                    <template scope="scope">
                       <p>{{scope.row.bindTime | dateTimeFormat}}</p>

                    </template>
                </el-table-column>
              <el-table-column
                  label="是否禁用"
                  prop="isEnable" width="230px">
                <template scope="scope">
                  <p>{{scope.row.isEnable | targetFilter }}</p>

                </template>
              </el-table-column>

                <el-table-column
                        label="操作">
                    <template scope="scope">

                      <el-button :type="scope.row.isEnable==1?'success':'primary'"  size="small"  v-confirm :confirm-text="scope.row.isEnable==1?'确认禁用？':'确认启用？'"  requestUrl="friend/bindUser/changeFriendBindUser.action" :confirm-data="{id:scope.row.id,isEnable:scope.row.isEnable==1?2:1}" @onConfirm="$refs.searchcarTable.search()">{{scope.row.isEnable==1?'禁用':'启用'}}</el-button>
                      <el-button :type="success"  size="small"  v-confirm  requestUrl="friend/bindUser/delFriendBindUser.action" :confirm-data="{id:scope.row.id}" @onConfirm="$refs.searchcarTable.search()">删除</el-button>
                    </template>
                </el-table-column>
            </template>
        </table-template>

    </el-row>

</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
import BasicModel from '@/framework/basic/BasicModel'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'friendBindUserList',
  data: function () {
    return {
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      currentTime: new Date().getTime(),
      queryParams: {
        startTime: null,
        isEnable:null,
        endTime: null,
        keyword: null
      }
    }
  },
  methods: {

    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.searchcarTable.search()
    },
    onStatusChange: function (value) {
      this.queryParams.status = value
      this.$refs['searchcarTable'].search()
    }
  },
  filters: {
    targetFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '启用'
          break
        case 2:
          str = '禁用'
          break
      }
      return str
    }
  }
}
</script>

<style scoped>

</style>
